import React from 'react';
import { useTranslation } from 'react-i18next';
import AzureVideo from '../../../assets/videos/Azure-academy.mp4';
import CorporateImg from '../../../assets/images/itm-academy-corporate.png';
import CorporateImg2 from '../../../assets/images/itm-academy-img.jpeg';
import './IntroSectionFormationAD.css';

const IntroSectionFormationAD2: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="intro-section-home intro-section-formation-ad-2">
      {/* Video and Images Sections */}
      <div className="intro-section">
        <div className="intro-row-1">
          <div className="intro-text-1">
            <h2>{t('formationAD.introSection.row1.title')}</h2>
            <h3>{t('formationAD.introSection.row1.description')}</h3>
          </div>
          <div className="intro-image">
            <video
              className="intro-media"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={AzureVideo} type="video/mp4" />
              {t('formationAD.introSection.videoNotSupported')}
            </video>
          </div>
        </div>

        <div className="intro-row-2">
          <div className="intro-text-2">
            <h2>{t('formationAD.introSection.row2.title')}</h2>
            <h3>{t('formationAD.introSection.row2.description')}</h3>
          </div>

          <div className="intro-image">
            <img
              className="intro-media"
              src={CorporateImg2}
              alt={t('formationAD.introSection.row2.imageAlt')}
            />
          </div>
        </div>

        <div className="intro-bottom-home">
          <div className="intro-row-1">
            <div className="intro-text-1">
              <h2>{t('formationAD.introSection.row3.title')}</h2>
              <h3>{t('formationAD.introSection.row3.description')}</h3>
            </div>
            <div className="intro-image">
              <img
                src={CorporateImg}
                loading="lazy"
                className="intro-media"
                alt={t('formationAD.introSection.row3.imageAlt')}
              />
            </div>
          </div>
        </div>

        <div className="intro-section-formation">
          <div className="centered-title-formation">
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSectionFormationAD2;
